import useKeyValueState from 'hooks/useKeyValueState';
import { createContext } from 'react';

const empty = {
  set: () => {},
  update: () => {},
  values: [],
  clear: () => {},
  remove: () => {},
};

export const DefaultUploaderContentext =
  createContext<ReturnType<typeof useKeyValueState>>(empty);

export const ExpensesUploaderContext =
  createContext<ReturnType<typeof useKeyValueState>>(empty);
